const getImageViewerDocuploadApiUrl = (state) => state.getIn(['config', 'imageViewerDocUploadApiUrl']);

export default getImageViewerDocuploadApiUrl;
